import React, { useState } from 'react';
import styles from './FAQComponent.module.css';

const faqs = [
  {
    question: 'Can I connect my existing CRM?',
    answer: 'Yes, Toxbox integrates seamlessly with major CRMs like Salesforce, HubSpot, Zoho, and more.',
    open: true, // First one open by default (matches your screenshot)
  },
  {
    question: 'How fast can I set up Toxbox AI?',
    answer: '',
  },
  {
    question: 'Is my data secure?',
    answer: '',
  },
  {
    question: 'Does Toxbox support multiple languages?',
    answer: '',
  },
  {
    question: 'Can Toxbox handle high call volumes?',
    answer: '',
  },
  {
    question: 'How does the AI qualify leads?',
    answer: '',
  },
  {
    question: 'Can I customize the AI conversation?',
    answer: '',
  },
  // Right column
  {
    question: 'Will my team get notifications for important leads?',
    answer: '',
  },
  {
    question: 'Can I see analytics and reports?',
    answer: '',
  },
  {
    question: 'Does Toxbox integrate with other tools?',
    answer: '',
  },
  {
    question: 'What happens if a call requires a human?',
    answer: '',
  },
  {
    question: 'Can I try Toxbox before committing?',
    answer: '',
  },
  {
    question: 'Is Toxbox suitable for small businesses?',
    answer: '',
  },
  {
    question: 'Does Toxbox comply with call recording laws?',
    answer: '',
  },
  {
    question: 'Can I export my leads and call data?',
    answer: '',
  },
];

const FAQComponent = () => {
  const [faqsState, setFaqsState] = useState(faqs);

  const toggleFAQ = (index) => {
    setFaqsState((prev) =>
      prev.map((faq, i) => ({
        ...faq,
        open: i === index ? !faq.open : false, // Only one open at a time (optional)
      }))
    );
  };

  const leftColumn = faqsState.slice(0, 7);
  const rightColumn = faqsState.slice(7);

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Frequently Asked Questions</h2>
          <p className={styles.subtitle}>Everything You Need to Know About ToxBox’s AI</p>
        </div>

        <div className={styles.grid}>
          {/* Left Column */}
          <div className={styles.column}>
            {leftColumn.map((faq, index) => (
              <div
                key={index}
                className={`${styles.faqItem} ${faq.open ? styles.active : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className={styles.question}>
                  <span>{faq.question}</span>
                  <span className={styles.icon}>{faq.open ? '−' : '+'}</span>
                </div>
                {faq.open && faq.answer && (
                  <div className={styles.answer}>
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Right Column */}
          <div className={styles.column}>
            {rightColumn.map((faq, index) => {
              const globalIndex = index + 7;
              return (
                <div
                  key={globalIndex}
                  className={`${styles.faqItem} ${faq.open ? styles.active : ''}`}
                  onClick={() => toggleFAQ(globalIndex)}
                >
                  <div className={styles.question}>
                    <span>{faq.question}</span>
                    <span className={styles.icon}>{faq.open ? '−' : '+'}</span>
                  </div>
                  {faq.open && faq.answer && (
                    <div className={styles.answer}>
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQComponent;